import { ENV_TYPE, NotificationCallbacks, Ops } from './declarations/message';
import InAppNotificationsHandler from './InAppNotificationsHandler';
import Logger from './logger';
import WSClient from './wsclient';

class InAppNotificationsManager {
  private static instance: InAppNotificationsManager;

  private ops: Ops;

  private wsAddress: string;

  private notificationsHandler: InAppNotificationsHandler;

  private wsClient: WSClient;

  private isInitiated: boolean = false;
  
  private env:ENV_TYPE = 'prod';

  private logger:Logger;

  private constructor(wsAddress: string, options: Ops,
    isInitiated?: boolean, callbacks?: NotificationCallbacks) {
    if (isInitiated) this.isInitiated = isInitiated;

    this.logger = new Logger(this.env);
    
    this.wsAddress = wsAddress;

    this.ops = options;

    this.notificationsHandler = new InAppNotificationsHandler(options.InaApp, callbacks);

    this.wsClient = new WSClient(this.wsAddress, this.notificationsHandler);

  }

  static createInstance(wsAddress: string, ops: Ops,env?:ENV_TYPE, callbacks?: NotificationCallbacks): InAppNotificationsManager {
    const instance = new InAppNotificationsManager(wsAddress, ops,
      true, callbacks);
    InAppNotificationsManager.instance = instance;
    if(env){
      instance.env = env;
      instance.logger.setLogLevel(env);
     }
    return InAppNotificationsManager.instance;
  }

  static getInstance(): InAppNotificationsManager {
    return InAppNotificationsManager.instance;
  }

  getInappNotificationsHandler(): InAppNotificationsHandler {
    return this.notificationsHandler;
  }

  getOps(): Ops {
    return this.ops;
  }

  getLogger():Logger {
    return this.logger;
  }

  requestNotifications(): void {
    this.wsClient.sendMessage({
      Action: 'Message',
      Type: 'AllNotifications',
    });
    this.logger.log('notification request sent');
    this.notificationsHandler.OnNotificationsRequest();
  }

  updateWsAddress(wsAddress: string): void {
    this.wsAddress = wsAddress;
    this.wsClient.updateAddress(wsAddress);
  }

  getWsClient(): WSClient {
    return this.wsClient;
  }
}
export default InAppNotificationsManager;